import { useEffect } from 'react';

const HEARTS = ['♥', '❤', '♡', '💕', '✦'];
const COLORS = ['#c45a7e', '#d020a8'];

export default function CursorTrail() {
  useEffect(() => {
    let count = 0;

    function spawnHeart(x: number, y: number) {
      const el = document.createElement('div');
      el.style.cssText = `
        position: fixed;
        pointer-events: none;
        z-index: 9999;
        left: ${x}px;
        top: ${y}px;
        transform: translate(-50%, -50%);
        font-size: ${10 + Math.random() * 10}px;
        color: ${COLORS[Math.floor(Math.random() * COLORS.length)]};
        opacity: 1;
        will-change: transform;
        user-select: none;
      `;
      el.textContent = HEARTS[Math.floor(Math.random() * HEARTS.length)];
      document.body.appendChild(el);

      const angle = (Math.random() - 0.5) * 60;
      const dist  = 30 + Math.random() * 40;
      let frame = 0;
      const maxFrames = 28;

      function animate() {
        frame++;
        const p    = frame / maxFrames;
        const ease = 1 - p * p;
        el.style.transform = `translate(${Math.sin(angle * 0.04) * dist * p - 50}%, ${-dist * p - 50}%) scale(${1 - p * 0.5})`;
        el.style.opacity   = String(ease * 0.85);
        if (frame < maxFrames) requestAnimationFrame(animate);
        else el.remove();
      }
      requestAnimationFrame(animate);
    }

    function onMove(e: MouseEvent) {
      count++;
      if (count % 4 === 0) spawnHeart(e.clientX, e.clientY);
    }

    window.addEventListener('mousemove', onMove, { passive: true });
    return () => window.removeEventListener('mousemove', onMove);
  }, []);

  return null;
}
